import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import EditTaskModal from './EditTask.jsx';
import './taskTabls.scss';
import { toast } from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FaCalendarAlt } from 'react-icons/fa';
import { IoArchiveOutline } from "react-icons/io5";
import { IoArchive } from "react-icons/io5";
import AddTaskModal from './AddTaskTable.jsx';
import { useNavigate } from 'react-router-dom';
import { removeCookie } from '../../utils/cookieUtils.js';
import { FaRegCalendarCheck } from "react-icons/fa";
import { Button, Spinner } from 'react-bootstrap';
import Cookies from "js-cookie";
const TaskTable = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [archivingTaskId, setArchivingTaskId] = useState(null);
  const [togglingStatusTaskId, setTogglingStatusTaskId] = useState(null);
  const [deletingTaskId, setDeletingTaskId] = useState(null);
  const [calendarLoadingId, setCalendarLoadingId] = useState(null);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const tasksPerPage = 8;

  // Filter states
  const [priorityFilter, setPriorityFilter] = useState('');
  const [deadlineFilter, setDeadlineFilter] = useState('');
  const [archiveFilter, setArchiveFilter] = useState('active');
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate()
  useEffect(() => {
    setLoading(true);
    const fetchTasks = async () => {
      try {
        const token = Cookies.get("token");
        if (!token) {
          toast.error("User not authenticated. Please log in.");
          setLoading(false);
          return;
        }
        const response = await axios.get(`${apiUrl}/tasks`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });

        setTasks(response.data.tasks || []);
      } catch (err) {
        console.error("Failed to fetch tasks:", err);
        toast.error("Failed to load tasks");
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [apiUrl]);

  //? Handle Edit Click
  const handleEditClick = (task) => {
    setSelectedTask(task);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTask(null);
  };

  //? Task update 
  const handleTaskUpdate = (updatedTask) => {
    setTasks((prev) =>
      prev.map((t) => (t._id === updatedTask._id ? updatedTask : t))
    );
  };

  const handleDeleteTask = async (taskId) => {
    setDeletingTaskId(taskId);
    try {
      const res = await axios.delete(`${apiUrl}/deletetask/${taskId}`);
      if (res.status === 200) {
        toast.success('Task deleted successfully!');
        setTasks((prevTasks) => prevTasks.filter((task) => task._id !== taskId));
      }
    } catch (error) {
      console.error('Error deleting task:', error);
      toast.error('Failed to delete task');
    } finally {
      setDeletingTaskId(null);
    }
  };

  // Filtering
  const filteredTasks = tasks.filter((task) => {
    const matchesPriority = priorityFilter ? task.priority === priorityFilter : true;
    const matchesDeadline = deadlineFilter
      ? new Date(task.deadline).toISOString().split('T')[0] === deadlineFilter
      : true;
    const matchesArchive =
      archiveFilter === 'all'
        ? true
        : archiveFilter === 'archived'
          ? task.isArchive === true
          : task.isArchive === false;

    return matchesPriority && matchesDeadline && matchesArchive;
  });

  // Pagination
  const indexOfLastTask = currentPage * tasksPerPage;
  const indexOfFirstTask = indexOfLastTask - tasksPerPage;
  const currentTasks = filteredTasks.slice(indexOfFirstTask, indexOfLastTask);
  const totalPages = Math.ceil(filteredTasks.length / tasksPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Archive Tasks
  const archiveHandle = async (taskId) => {
    try {
      setArchivingTaskId(taskId);
      const response = await axios.put(`${apiUrl}/archive/${taskId}`, {}, { withCredentials: true });
      if (response.data.success) {
        toast.success('Task archived successfully');
        setTasks((prev) =>
          prev.map((task) =>
            task._id === taskId ? { ...task, isArchive: true } : task
          )
        );
      }
    } catch (error) {
      console.error('Error archiving task', error);
      toast.error('Failed to archive task');
    } finally {
      setArchivingTaskId(null);
    }
  };

  // Checkbox Handle
  const checkBoxHandle = async (taskId) => {
    setTogglingStatusTaskId(taskId);
    try {
      const response = await axios.put(`${apiUrl}/task/status/${taskId}`, {}, { withCredentials: true });
      if (response.data.success) {
        const updated = response.data.updatedTask;
        setTasks((prev) =>
          prev.map((t) => (t._id === updated._id ? updated : t))
        );
        toast.success(`Task marked as ${updated.status ? 'Done' : 'Pending'}`);
      }
    } catch (error) {
      console.error('Failed to toggle task status:', error);
      toast.error('Failed to update task status');
    } finally {
      setTogglingStatusTaskId(null);
    }
  };

  //?
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  //?  Calendar Handle
  const calendarHandle = async (taskId) => {
    if (calendarLoadingId === taskId) return;
    const access_token = getCookie("google_access_token");
    setCalendarLoadingId(taskId);

    if (!access_token) {
      toast.error("Google access token is missing. Please log in again.");
      navigate('/slack/dashboard/calendar');
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/add-task-calendar`,
        {
          params: { taskId, access_token },
          withCredentials: true,
        }
      );

      toast.success('Task added to Google Calendar');
      console.log("✅ Google Calendar Event Added:", response.data);
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task._id === taskId ? { ...task, isSentToCalendar: true } : task
        )
      );

    } catch (error) {
      const status = error.response?.status;
      const message = error.response?.data?.error;

      if (status === 401) {
        toast.error("Google session expired. Please re-authenticate.");
        removeCookie("google_access_token");
        navigate("/dashboard/calendar");
      } else if (message === "Task does not have a due date") {
        toast.error("Task deadline is missing.");
      } else {
        toast.error("Failed to add task to calendar.");
        console.error("❌ Error adding to Google Calendar:", message || error.message);
      }
    } finally {
      setCalendarLoadingId(null);
    }
  };

  // Handle deleting task from Google Calendar
  // const deleteCalendarHandle = async (taskId, setCalendarLoadingId, setTaskList) => {
  //   const access_token = getCookie("google_access_token");

  //   if (!access_token) {
  //     toast.error("Please authenticate with Google.");
  //     setTimeout(() => navigate("/slack/dashboard/calendar"), 2000);
  //     return;
  //   }

  //   setCalendarLoadingId(taskId);

  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/delete-task-calendar`,
  //       {
  //         params: { taskId, access_token },
  //         withCredentials: true,
  //       }
  //     );

  //     setTaskList((prev) =>
  //       prev.map((task) =>
  //         task._id === taskId
  //           ? { ...task, isSentToCalendar: false, calendarEventId: null }
  //           : task
  //       )
  //     );

  //     toast.success(response.data.message || "Task removed from Google Calendar");
  //     console.log("✅ Google Calendar Event Deleted:", response.data);
  //   } catch (error) {
  //     if (
  //       error.response?.status === 401 ||
  //       error.response?.data?.error?.includes("invalid_token")
  //     ) {
  //       toast.error("Google session expired. Please re-authenticate.");
  //       document.cookie = "google_access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  //       setTimeout(() => navigate("/slack/dashboard/calendar"), 2000);
  //     } else {
  //       toast.error("Failed to remove task from calendar");
  //       console.error("❌ Error deleting from Google Calendar:", error.response?.data || error.message);
  //     }
  //   } finally {
  //     setCalendarLoadingId(null);
  //   }
  // };

  //?

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allTaskIds = currentTasks.map((task) => task._id);
      setSelectedTasks(allTaskIds);
    } else {
      setSelectedTasks([]);
    }
  };

  // Handle individual task checkbox
  const handleSelectTask = (taskId) => {
    setSelectedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };
  //? Delete All Select Tasks
  const handleDeleteSelected = async () => {
    if (window.confirm(`Are you sure you want to delete ${selectedTasks.length} task(s)?`)) {
      setIsDeleting(true);
      try {
        await axios.post(`${apiUrl}/delete/api`, {
          taskIds: selectedTasks,
        });
        setTasks((prevTasks) =>
          prevTasks.filter((task) => !selectedTasks.includes(task._id))
        );

        setSelectedTasks([]);
        toast.success('Selected tasks deleted!');
      } catch (error) {
        console.error('Error deleting tasks:', error);
        toast.error('Failed to delete tasks.');
      } finally {
        setIsDeleting(false); // Stop loading
      }
    }
  };

  return (
    <div className="table-responsive">
      <div className="filters mb-3 d-flex gap-3 align-items-center">
        <select
          className="form-select w-auto"
          value={priorityFilter}
          onChange={(e) => setPriorityFilter(e.target.value)}
        >
          <option value="">All Priorities</option>
          <option value="High">High</option>
          <option value="Medium">Medium</option>
          <option value="Low">Low</option>
        </select>

        <input
          type="date"
          className="form-control w-auto"
          value={deadlineFilter}
          onChange={(e) => setDeadlineFilter(e.target.value)}
        />

        <select
          className="form-select w-auto"
          value={archiveFilter}
          onChange={(e) => setArchiveFilter(e.target.value)}
        >
          <option value="all">All</option>
          <option value="archived">Archived</option>
          <option value="active">Active</option>
        </select>

        <button
          className="btn btn-secondary"
          onClick={() => {
            setPriorityFilter('');
            setDeadlineFilter('');
            setArchiveFilter('all');
          }}
        >
          Clear Filters
        </button>
        {selectedTasks.length > 0 && (
          <div>
            {selectedTasks.length > 0 && (
              <div>
                <button
                  className="btn btn-danger"
                  onClick={handleDeleteSelected}
                  disabled={isDeleting} // Disable during loading
                  style={{ minHeight: '38px' }} // Match Bootstrap btn height
                >
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: '150px',
                      height: '20px',
                    }}
                  >
                    {isDeleting ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        style={{ width: '16px', height: '16px' }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : (
                      `Delete Selected (${selectedTasks.length})`
                    )}
                  </span>
                </button>
              </div>
            )}
          </div>
        )}
        <button
          className="btn btn-primary"
          onClick={() => setShowAddTaskModal(true)}
        >
          Add New Task
        </button>
      </div>
      <AddTaskModal
        show={showAddTaskModal}
        onHide={() => setShowAddTaskModal(false)}
      />
      <div>
        <table className="table table-sm custom-table">
          <thead>
            <tr>
              <th className="select-all-header">
                <div className="select-all-container">
                  <input
                    type="checkbox"
                    className="form-check-input ms-2"
                    checked={
                      currentTasks.length > 0 &&
                      selectedTasks.length === currentTasks.length
                    }
                    onChange={handleSelectAll}
                  />
                  <span>Select All</span>
                </div>
              </th>
              <th>Workspace</th>
              <th>Task</th>
              <th>Priority</th>
              <th>Deadline</th>
              <th>Tone</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              Array.from({ length: tasksPerPage }).map((_, index) => (
                <tr key={`skeleton-${index}`}>
                  <td>
                    <Skeleton width={30} height={20} />
                  </td>
                  <td>
                    <Skeleton width={60} height={20} />
                  </td>
                  <td className="task-column">
                    <Skeleton width={250} height={20} />
                  </td>
                  <td>
                    <Skeleton width={50} height={20} />
                  </td>
                  <td>
                    <Skeleton width={100} height={20} />
                  </td>
                  <td>
                    <Skeleton width={80} height={20} />
                  </td>
                  <td>
                    <Skeleton width={100} height={30} />
                  </td>
                  <td>
                    <Skeleton width={140} height={30} />
                  </td>
                </tr>
              ))
            ) : currentTasks.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  No tasks found
                </td>
              </tr>
            ) : (
              currentTasks.map((task) => (
                <tr key={task._id}>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedTasks.includes(task._id)}
                      onChange={() => handleSelectTask(task._id)}
                    />
                  </td>
                  <td className="worksapceName-column">{task?.workspaceName}</td>
                  <td className="task-column">{task?.task}</td>
                  <td>{task.priority}</td>
                  <td>
                    {task.deadline
                      ? new Date(task.deadline).toLocaleDateString()
                      : 'No deadline'}
                  </td>
                  <td>{task.tone}</td>
                  <td>
                    <button
                      className={`btn btn-sm ${task.status ? 'btn-success' : 'btn-warning'
                        } d-flex align-items-center justify-content-center`}
                      disabled={togglingStatusTaskId === task._id}
                      id={`checkbox-${task._id}`}
                      checked={task.status === true}
                      onClick={() => checkBoxHandle(task._id)}
                    >
                      {togglingStatusTaskId === task._id ? (
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"

                        ></span>
                      ) : task.status ? (
                        'Done'
                      ) : (
                        'Pending'
                      )}
                    </button>
                  </td>
                  <td>
                    <FaEdit
                      className="icon edit d-inline-block"
                      title="Edit"
                      onClick={() => handleEditClick(task)}
                    />
                    {deletingTaskId === task._id ? (
                      <span
                        className="spinner-border spinner-border-sm text-danger ms-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <FaTrash
                        className="icon delete d-inline-block ms-2"
                        title="Delete"
                        onClick={() => handleDeleteTask(task._id)}
                      />
                    )}
                    <span
                      className={`icon d-inline-block ms-2 ${task.isArchive ? 'btn-success' : 'btn-secondary'
                        }`}
                      title={task.isArchive ? 'Archived' : 'Archive'}
                      onClick={() => {
                        if (!task.isArchive) archiveHandle(task._id);
                      }}
                      disabled={task.isArchive || archivingTaskId === task._id}
                    >
                      {archivingTaskId === task._id ? (
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : task.isArchive ? (
                        <IoArchive />
                      ) : (
                        <IoArchiveOutline />
                      )}
                    </span>
                    <span
                      className="icon d-inline-block ms-2"
                      disabled={task.isSentToCalendar || calendarLoadingId === task._id}
                    >
                      <Button
                        key={task._id}
                        variant={task.isSentToCalendar ? "success" : "outline-primary"}
                        size="sm"
                        disabled={calendarLoadingId === task._id || task.isSentToCalendar}
                        onClick={() => {
                          if (!task.isSentToCalendar) {
                            calendarHandle(task._id, setCalendarLoadingId,);
                          }
                        }}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {calendarLoadingId === task._id ? (
                          <Spinner animation="border" size="sm" className="me-1" role="status" />
                        ) : task.isSentToCalendar ? (
                          <>
                            <FaRegCalendarCheck className="me-1" style={{ verticalAlign: 'middle' }} />
                            Sent to Calendar
                          </>
                        ) : (
                          <>
                            <FaCalendarAlt className="me-1" style={{ verticalAlign: 'middle' }} />
                            Add to Calendar
                          </>
                        )}
                      </Button>
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <EditTaskModal
        show={showModal}
        onHide={handleCloseModal}
        task={selectedTask}
        onUpdate={handleTaskUpdate}
        apiUrl={apiUrl}
      />

      {
        totalPages > 1 && !loading && (
          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center mt-3">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        )
      }
    </div >
  );
};

export default TaskTable;